export const styles = {
  // Item cart
  divRow: {
    display: "flex",
    border: "1px solid gray",
    margin: 5,
    padding: 5,
    borderStyle: "dotted",
    borderRadius: 10,
    justifyContent: "center",
    alignContent: "flex-start",
    alignItems: "center",
    flexDirection: "column"
  },
  divColumns: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    alignItems: "center"
    //backgroundColor: "blue"
  },
  divButtons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: 12,
    justifyContent: "center",
    marginLeft: 25,
    marginRight: 25
  },
  divH6: {
    textTransform: "uppercase",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  //SideBarCart
  containerSideBar: {
    backgroundColor: "white",
    width: 360,
    height: "100%"
  },
  titleHeader: { fontSize: 20 },
  containerPromo: {
    borderBottom: "1px solid lightgray",
    borderTop: "1px solid lightgray"
  },
  containerItemsCart: {
    height: "63%", //verificar
    overflowY: "auto",
    display: "flex",
    flexDirection: "column"
  },
  containerTop: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    borderTop: "1px solid lightgray"
  },
  addTitle: {
    color: "gray"
  },
  sentTitle: {
    color: "gray",
    fontSize: 13
  },
  inputAddTitle: {
    border: "1px solid #d3d3d3",
    width: "100%",
    padding: 5
  },
  labelFrase: {
    display: "flex",
    fontSize: "x-small",
    lineHeight: "1em",
    textAlign: "justify",
    paddingTop: 6,
    width: "90%",
    overflow: "hidden"
  },
  divSubTot: {
    display: "flex",
    justifyContent: "flex-end"
  },
  spanSubTot: {
    textAlign: "right",
    display: "flex",
    justifyItems: "center",
    flexDirection: "column",
    width: "100%"
  },
  h2SubTot: {
    color: "blak",
    fontSize: 15,
    fontWeight: "bold",
    textShadow: "1px 0 gray"
  },
  divPrice: {
    color: "blak",
    fontSize: 20,
    fontWeight: "bold"
  },
  cartEmpty: {
    display: "flex",
    paddingTop: "90%",
    justifyContent: "center",
    alignItems: "flex-start"
  },
  detailsView: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
  },
  showName: {
    display: "flex",
    width: "90%",
    flexDirection: "row"
  }
};
